import { withInstall } from '@hd-front-end/utils'
import TimeSelect from './src/time-select.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElTimeSelect: SFCWithInstall<typeof TimeSelect> =
  withInstall(TimeSelect)
export default ElTimeSelect

export * from './src/time-select'
